import { Component } from '@angular/core';

@Component({
  selector: 'app-buyers-data-empty',
  templateUrl: './buyers-data-empty.component.html',
  styleUrls: ['./buyers-data-empty.component.scss']
})
export class BuyersDataEmptyComponent {

}
